export default __webpack_public_path__ + "static/media/shadow.5ce4c341.png";